<script setup lang="ts">
definePage({ redirect: '/trx' });
</script>

<template>
  <span />
</template>
